import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router, UrlTree, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { CurrentUserService } from '../services/current-user.service';
import { SessionDataService } from '../services/session-data.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(
    private currentUserService: CurrentUserService,
    private router: Router,
    private sessionDataService: SessionDataService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.resolveAuth(state.url);
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.resolveAuth(state.url);
  }

  private resolveAuth(targetUrl: string): Observable<boolean | UrlTree> {
    return this.currentUserService.currentUser.pipe(
      take(1),
      map(result => {
        if (result && result.currentUser) {
          if (this.sessionDataService.sessionData()?.passwordExpired) {
            return this.router.createUrlTree(['/password-expired']);
          }
          // Check if user needs to accept GDPR
          if (!result.currentUser.acceptDpa) {
            return this.router.createUrlTree(['/gdpr-acceptance'], { queryParams: { returnUrl: targetUrl } });
          }
          return true;
        }
        return this.router.createUrlTree(['/login'], { queryParams: { returnUrl: targetUrl } });
      })
    );
  }
}